module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold_1.9a4b4f8c.eot";